import { render, staticRenderFns } from "./senderaddress.vue?vue&type=template&id=b75806f2"
import script from "./senderaddress.vue?vue&type=script&lang=js"
export * from "./senderaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports